export default __webpack_public_path__ + "static/media/Gaurav MSAC - 530_GAURAV KUMAR VERMA.411f9f7e.png";